/**
 * 需求来源：docs/新增CJ招聘落地页需求/prompt.md、docs/新增CJ招聘落地页需求/CJ-333291
 * 注意事项：
 * 1. /careers 为纯展示型 SSR 招聘落地页，只返回 SEO 与 CDN_HOST，不依赖后端接口。
 * 2. SEO 文案围绕 CJ 跨境电商海外招聘定位。
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @param {Function} request - 统一请求函数（本页面未使用）
 * @returns {Object} 页面初始化数据，包含 __seo 和 cdnHost 字段
 */
async function fetchData(ctx, request) {
  let cdnHost = '';
  // publicImg：图片基址，按环境取 config.view.variable.PUBLIC_IMG（dev=/egg/image 本地直出，prod=OSS+/egg/image）
  let publicImg = '';
  // 获取 Egg.js 原始上下文：SSR 框架直传原始 ctx（ctx.app 存在）或统一上下文包装（ctx.ctx）
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
    publicImg = (viewVar && viewVar.PUBLIC_IMG) || '';
  }
  // CSR fallback: 从 layout 模板注入的全局变量获取
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  if (!publicImg && typeof PUBLIC_IMG !== 'undefined') {
    publicImg = PUBLIC_IMG;
  }
  return {
    cdnHost: cdnHost,
    publicImg: publicImg,
    __seo: {
      title: 'Careers at CJdropshipping | Global Cross-border E-commerce Jobs',
      keywords:
        'CJdropshipping careers,cross-border e-commerce jobs,dropshipping careers,overseas market lead,overseas BD,overseas HR,global hiring',
      description:
        'Join CJdropshipping and build the future of cross-border e-commerce and dropshipping. Explore global open roles across Southeast Asia, Europe, the Middle East and the Americas.',
    },
  };
}

module.exports = fetchData;
